module.exports = __webpack_public_path__ + "static/daw-code-b874aaaab5d495926e728e9ff9b286eb.png";